import { NgModule } from '@angular/core';
import {HashLocationStrategy, LocationStrategy, PathLocationStrategy} from '@angular/common';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';

import { NgScrollbarModule } from 'ngx-scrollbar';

// Import routing module
import { AppRoutingModule } from './app-routing.module';

// Import app component
import { AppComponent } from './app.component';

// Import containers
import {
  DefaultAsideComponent,
  DefaultFooterComponent,
  DefaultHeaderComponent,
  DefaultLayoutComponent
} from './containers';
import { ThemeSwitcherComponent } from './containers/default-layout/default-header/theme-switcher/theme-switcher.component';

import {
  AvatarComponent,
  BadgeModule,
  BreadcrumbModule,
  ButtonModule, DropdownComponent, DropdownItemDirective, DropdownMenuDirective, DropdownToggleDirective,
  FooterModule,
  GridModule,
  HeaderModule,
  NavModule,
  SidebarModule} from '@coreui/angular-pro';

import { IconModule, IconSetService } from '@coreui/icons-angular';
import {SharedAuthModule} from "./shared/auth/shared-auth.module";
import {AuthModule} from "@auth0/auth0-angular";
import {HttpClientModule} from "@angular/common/http";
import {SharedToastModule} from "./shared/toast/shared-toast.module";

const APP_CONTAINERS = [
  DefaultAsideComponent,
  DefaultFooterComponent,
  DefaultHeaderComponent,
  DefaultLayoutComponent,
  ThemeSwitcherComponent
];

@NgModule({
  declarations: [AppComponent, APP_CONTAINERS],
  imports: [
    HttpClientModule,
    AuthModule.forRoot({
      domain: environment.auth.domain,
      clientId: environment.auth.clientId,
      authorizationParams: {
        redirect_uri: environment.auth.redirectUri,
        audience: environment.auth.audience,
        scope: 'openid email profile offline_access',
      },
      useRefreshTokens: true,
      cacheLocation: 'localstorage',
      skipRedirectCallback: window.location.pathname.includes('/connectors'),
      httpInterceptor: {
        allowedList: [
          {
            uri: `${environment.apiUrl}/*`,
            tokenOptions: {
              authorizationParams: {
                audience: environment.auth.audience,
                scope: 'openid email profile',
              },
            },
          },
        ],
      },
    }),
    SharedAuthModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    SharedToastModule.forRoot(),
    AppRoutingModule,
    BreadcrumbModule,
    FooterModule,
    GridModule,
    HeaderModule,
    SidebarModule,
    IconModule,
    NavModule,
    ButtonModule,
    SidebarModule,
    BadgeModule,
    NgScrollbarModule,
    DropdownItemDirective,
    AvatarComponent,
    DropdownToggleDirective,
    DropdownComponent,
    DropdownMenuDirective
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    IconSetService,
    Title
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
